import * as React from 'react';
import {connect} from 'react-redux';
import ScrollContainer from 'react-indiana-drag-scroll';
import {updateGloop} from "../../../actions/update";

export class TextControleComponent extends React.Component {
	state = {};

	getFontList(){
		const {options} = this.props;
		let fonts = (options.data.fonts ? options.data.fonts : '').split(';');
		fonts = fonts.filter(item => item );
		fonts = fonts.map((item)=>{
			if(!item){
				return null;
			}
			let temp = item.split('|')
			if(temp.length>1){
				return {
					title : temp[0],
					font : temp[1]
				}
			}else {
				return {
					title : temp[0],
					font : temp[0]
				}
			}
		});
		return fonts;
	}

	getColorsList(){
		const {options} = this.props;
		let colors = (options.data.font_colors ? options.data.font_colors : '').split('|');
		return colors
	}

	calculateFontSize(){

	}

	render() {
		const {ui,options, gloop = {}} = this.props;
		const {data = {}} = gloop;
		if(!options || !gloop){
			return '';
		}
		// const colors = [
		// 	'#000',
		// 	'#fff',
		// 	'#00C9A7',
		// 	'#845EC2',
		// 	'#C34A36',
		// 	'#4B4453',
		// 	'#f00',
		// 	'#0f0',
		// 	'#00f',
		// 	'#ff0'
		// ];
		const colors = this.getColorsList();
		let fonts = this.getFontList();
		let font = data.font  ? data.font : fonts[0].font;
		let color = data.color ? data.color : colors[0];
		//TODO: colors hardcoded


		return (
			<div className={'gloop-text-controls-block'}>
				<ScrollContainer className="scroll-container" nativeMobileScroll={true}>
					<div className={'gloop-font-family-controls'}>
						<ul>
							{fonts.map( (item,index ) => {
								return (
									<li>
										<span href={'#'} data-font-family={"'" + item.font + "', serif"}
											style={{'font-family': '"' + item.font + '", sans-serif'}}
											className={item.font == font ? 'active' : ''}
											onClick={(e) => {
												e.preventDefault();
												updateGloop({
													font : item.font,
												},false,{
													screen_name : 'text_font',
													button_id : index
												});
											}}
										>{item.title}</span>
									</li>
								);
							})}
						</ul>
					</div>
				</ScrollContainer>
				<ScrollContainer className="scroll-container"  nativeMobileScroll={true}>
					<div className={'gloop-text-color-controls'}>
						<ul>
							{colors.map((item,index)=>{
								return (<li>
									<span
										href="#"
										data-color={item}
										style={{'background-color': item}}
										className={(color == item ? 'active' : '') + ( item == '#FFFFFF' ? ' white' : '' )}
										onClick={(e) => {
											e.preventDefault();
											updateGloop({
												color : item,
											},false,{
												screen_name : 'text_color',
												button_id : index
											});
										}}
									>&nbsp;</span>
								</li>)
							})}
						</ul>
					</div>
				</ScrollContainer>
			</div>
		)
	}
}



const mapStateToProps = (state) => {
	const gloop = state.gloops[state.activeGloop];
	let options = null;
	if(gloop && gloop.data){
		options = state.gloopsOptions[gloop.data.original_gloop[0]]
	}
	return {
		ui: state.ui,
		gloop : gloop,
		options : options
	};
}
const TextControle = connect(mapStateToProps)(TextControleComponent)
export default TextControle;
